import { render } from "./TheParliament.vue?vue&type=template&id=c86d57ea&scoped=true"
import script from "./TheParliament.vue?vue&type=script&lang=js"
export * from "./TheParliament.vue?vue&type=script&lang=js"

import "./TheParliament.vue?vue&type=style&index=0&id=c86d57ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c86d57ea"]])

export default __exports__